module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"a":"Années d\u0027expérience"},"en":{"a":"Years of experience"}}')
  delete Component.options._Ctor
}
